function _extends() {return _extends = Object.assign ? Object.assign.bind() : function (n) {for (var e = 1; e < arguments.length; e++) {var t = arguments[e];for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);}return n;}, _extends.apply(null, arguments);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable max-statements */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import sanitizeHtml from 'sanitize-html';
import { risonDecodeOrIgnore } from "../utils";
import { Translate } from "../I18N";
import { atomStore, userAtom } from "../V2/atoms";
import { notify } from "../Notifications/actions/notificationsActions";
import { store } from "../store";
import { MarkdownLink, SearchBox, MarkdownMedia, ItemList } from "./components";
import CustomHookComponents from "./CustomHooks";
import markdownToReact from "./markdownToReact";
import { ValidatedElement } from "./ValidatedElement";
import { errorCollector, visualizationHtmlTags } from "./utils";

class MarkdownViewer extends Component {
  static errorHtml(index, message) {
    return (/*#__PURE__*/
      _jsx("p", { className: "error" }, index, /*#__PURE__*/
      _jsx("br", {}), /*#__PURE__*/
      _jsx("strong", {}, void 0, /*#__PURE__*/
      _jsx("i", {}, void 0, /*#__PURE__*/
      _jsx(Translate, { translationKey: "Custom component error" }, void 0, "Custom component markup error: unsupported values! Please check your configuration"

      )
      )
      ), /*#__PURE__*/
      _jsx("br", {}),
      message, /*#__PURE__*/
      _jsx("br", {})
      ));

  }

  static customHook(config, index) {
    const props = risonDecodeOrIgnore(config);
    if (!CustomHookComponents[props.component]) {
      throw new Error('Invalid  component');
    }
    const Element = CustomHookComponents[props.component];
    return /*#__PURE__*/React.createElement(Element, _extends({}, props, { key: index }));
  }

  componentDidMount() {
    if (errorCollector.hasErrors()) {
      errorCollector.report();

      const user = atomStore.get(userAtom);
      if (user._id) {
        // prepare the error message to be shown to the logged in user
        store.dispatch(notify(errorCollector.display(), 'warning', 20000));
      }

      errorCollector.clear();
    }
  }

  inlineComponent(type, config, index) {
    const { compact } = this.props;
    let result;
    if (type === 'list') {
      result = this.list(config, index);
    }

    if (type === 'link') {
      result = /*#__PURE__*/React.createElement(MarkdownLink, _extends({}, risonDecodeOrIgnore(config), { key: index }));
    }

    if (type === 'searchbox') {
      result = /*#__PURE__*/React.createElement(SearchBox, _extends({}, risonDecodeOrIgnore(config), { key: index }));
    }

    if (['vimeo', 'youtube', 'media'].includes(type)) {
      result = /*#__PURE__*/
      _jsx("div", {}, index, /*#__PURE__*/
      _jsx(MarkdownMedia, { config: config, compact: compact }, index)
      );

    }

    if (type === 'customhook') {
      result = MarkdownViewer.customHook(config, index);
    }
    return result;
  }

  customComponent(type, config, index, children) {
    try {
      if (typeof type === 'function' || typeof type === 'object') {
        const Element = type;
        return (/*#__PURE__*/
          React.createElement(Element, _extends({}, config, { key: index }),
          children
          ));

      }

      if (type) {
        return this.inlineComponent(type, config, index);
      }
    } catch (error) {
      return MarkdownViewer.errorHtml(index, error.message);
    }

    return false;
  }

  list(_config, index) {
    const listData = this.props.lists[this.renderedLists] || {};
    const output = /*#__PURE__*/
    _jsx(ItemList, {

      link: `/library/${listData.params}`,
      items: listData.items,
      options: listData.options }, index
    );

    this.renderedLists += 1;
    return output;
  }

  render() {
    this.renderedLists = 0;

    if (typeof this.props.markdown !== 'string') {
      return false;
    }

    const sanitizedMarkdown = !this.props.sanitized ?
    this.props.markdown :
    sanitizeHtml(this.props.markdown, {
      allowedTags: visualizationHtmlTags,
      allowedAttributes: false
    });

    const ReactFromMarkdown = markdownToReact(
      sanitizedMarkdown,
      this.customComponent.bind(this),
      this.props.html
    );

    if (!ReactFromMarkdown) {
      return false;
    }

    return ValidatedElement(
      'div',
      { className: 'markdown-viewer' },
      React.Children.toArray(ReactFromMarkdown),
      this.props.sanitized
    );
  }
}

MarkdownViewer.defaultProps = {
  lists: [],
  markdown: '',
  html: false,
  compact: false,
  sanitized: true
};









export default MarkdownViewer;